export default "__VITE_ASSET__CNkwpNYB__ 600w";